module.exports = "/images/vendor/vue-pdf-app/dist/icons/pdf.svg?6781170c0c08b15fff2d642575be96ce";